module.exports = __webpack_public_path__ + "assets/96b4759f116a47b229959d8e75eb431e.png";